import { TemplateLink } from "./TemplateLink"

export default function MadSadGladContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Mad / Sad / Glad was popularized by Esther Derby and Diana Larsen in{" "}
        <a
          href="https://pragprog.com/titles/dlret/agile-retrospectives/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <em>Agile Retrospectives</em>
        </a>{" "}
        (2006), the book that basically wrote the modern retro playbook. The
        insight: teams are made of humans, and humans make better decisions
        when they've had a chance to name what they're feeling before they
        try to solve anything.
      </p>

      <h2>When to use this format</h2>
      <p>
        Use it after something emotional has happened. A rough launch. An
        incident. A reorg. A departure. The columns give people permission
        to say what's actually shaping their week, instead of pretending
        everything is a process problem. It also works well with new teams
        still figuring out how honest they can be with each other.
      </p>

      <blockquote>
        Regardless of what we discover, we understand and truly believe
        that everyone did the best job they could, given what they knew at
        the time, their skills and abilities, the resources available, and
        the situation at hand.
        <br />
        <em>&mdash; Norm Kerth's Retrospective Prime Directive</em>
      </blockquote>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it when the team is fine. Forcing emotional reflection on a
        team that just wants to talk about test flakiness reads as
        performative. You're making the retro heavier than the sprint
        warranted, and people will remember it as the meeting where you
        made them share feelings for no reason. Reach for{" "}
        <TemplateLink to="plus-delta">Plus / Delta</TemplateLink> instead.
      </p>

      <h2>How to run it</h2>
      <p>
        Silent writing for five to seven minutes. If your team uses
        Retroboard's hidden-votes mode, this is the format where it earns
        its keep; people vote on which items to discuss without seeing
        anyone else's votes first, and the emotional items surface honestly
        instead of getting quietly deprioritized. Discuss the top themes
        before jumping to actions; if there are actions, they'll fall out
        naturally.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        Turns into a therapy session with no exit ramp. Keep a soft timebox
        on the emotional discussion (fifteen minutes tops) and always end
        by asking: what's one thing we could do differently that would move
        us from Sad or Mad toward Glad? Naming the feeling is step one,
        not the whole point.
      </p>
    </>
  )
}
